import React, { useMemo, useState } from "react";
import "./styles.css";
import { BaseDropdown, BaseInput, Ptag } from "components/core";
import GradeAccordion from "./GradeAccordion";
import { colors } from "theme";
import DependentsCard from "./DependentsCard";
import { RoomRentContainer, RoomRentContainerHeader } from "./styles";
import { Field } from "formik";

const FORMIK_ROOM_RENT = [
  "room_rent_limit",
  "room_rent_limit_min",
  "room_rent_limit_max",
  "room_rent_limit_max_normal",
  "metro_room_rent_limit_normal",
  "room_rent_remarks",
  "room_rent_limit_max_icu",
  "metro_room_rent_limit_normal_max",
  "metro_room_rent_limit_icu",
  "metro_room_rent_limit_icu_max",
  "metro_room_rent_remarks",
  "non_metro_room_rent_limit_normal",
  "non_metro_room_rent_limit_normal_max",
  "non_metro_room_rent_limit_icu",
  "non_metro_room_rent_limit_icu_max",
  "non_metro_room_rent_remarks",
  "default_metro_room_rent_limit_normal",
  "default_metro_room_rent_limit_normal_max",
  "default_metro_room_rent_limit_icu",
  "default_metro_room_rent_limit_icu_max",
  "default_metro_room_rent_remarks",
]

const GradeRoomLimit = ({ formikProps, attribute, toggleHandler }) => {
  const doesValueExist = useMemo(() => {
    const values = formikProps.values;
    return FORMIK_ROOM_RENT.some(key => values[key]);
  }, [formikProps]);

  let selectedDetails = localStorage.getItem("eb_selected_values");
  if (selectedDetails) {
    selectedDetails = JSON.parse(selectedDetails);
  }

  const isFlex = useMemo(() => {
    return selectedDetails?.flex;
  }, [selectedDetails]);

  const initalToggleStatus = useMemo(() => {
    let status = false;
    if (!attribute?.toggle) {
      status = true;
    }
    if (doesValueExist) status = true;
    return status;
  }, [formikProps, attribute]);

  const [toggleStatus, setToggleStatus] = useState(initalToggleStatus);
  const doesRangeExist = useMemo(() => {
    return attribute.selectable_values.length > 0;
  }, [attribute]);

  const options = useMemo(() => {
    return attribute.selectable_values.map((val) => ({
      label: val,
      value: val,
    }));
  }, [attribute]);

  const interstitialToggler = (bool) => {
    setToggleStatus(bool);
    if(!bool) {
      FORMIK_ROOM_RENT.forEach(key => {
        formikProps.setFieldValue(key, "", true);
      });
    }
    toggleHandler &&
      toggleHandler(bool, attribute?.attribute_data?.attribute_name);
  };

  const renderMetroNonMetro = (type, split) => {
    const title = type === "metro" ? "Metro Cities" : "Non-Metro Cities";
    return (
      <div className="grade-summary-inner">
        {!split ? (
          <Ptag
            fontSize="18px"
            fontWeight="500"
            marginBottom="16px"
            marginTop="16px"
          >
            {title}
          </Ptag>
        ) : (
          <div style={{ marginTop: "16px" }} />
        )}
        <RoomRentContainer>
          <RoomRentContainerHeader>
            <div></div>
            <Ptag fontSize="14px">% of SI Per Day Limit</Ptag>
            <Ptag fontSize="14px">Max Per Day Limit</Ptag>
          </RoomRentContainerHeader>
          <RoomRentContainerHeader>
            <Ptag fontSize="16px" fontWeight="700">
              Normal Room
            </Ptag>
            <BaseInput
              disabled={!toggleStatus}
              fontSize="16px !important"
              // formatToRupee
              formikProps={{
                ...formikProps,
                name: `${type}_room_rent_limit_normal`,
              }}
            />
            <BaseInput
              disabled={!toggleStatus}
              fontSize="16px !important"
              formikProps={{
                ...formikProps,
                name: `${type}_room_rent_limit_normal_max`,
              }}
            />
          </RoomRentContainerHeader>
          {/* Error display for Normal Room - show error if at least one field is not filled */}
          {(type === "non_metro" || type === "default_metro") && (
            formikProps.errors[`${type}_room_rent_limit_normal`] && formikProps.touched[`${type}_room_rent_limit_normal`] ? (
             null
            ) : null
          )}
          <RoomRentContainerHeader
            style={{
              marginBottom: "14px",
            }}
          >
            <Ptag fontSize="16px" fontWeight="700">
              ICU Room
            </Ptag>
            <BaseInput
              disabled={!toggleStatus}
              fontSize="16px !important"
              // formatToRupee
              formikProps={{
                ...formikProps,
                name: `${type}_room_rent_limit_icu`,
              }}
            />
            <BaseInput
              disabled={!toggleStatus}
              fontSize="16px !important"
              formikProps={{
                ...formikProps,
                name: `${type}_room_rent_limit_icu_max`,
              }}
            />
          </RoomRentContainerHeader>
          {/* Error display for ICU Room - show error if at least one field is not filled */}
          {(type === "non_metro" || type === "default_metro") && (
            formikProps.errors[`${type}_room_rent_limit_icu`] && formikProps.touched[`${type}_room_rent_limit_icu`] ? (
             null
            ) : null
          )}     
          <BaseInput
            staticLabel="Remarks (optional)"
            disabled={!toggleStatus}
            fontSize="16px !important"
            type="text"
            formikProps={{
              ...formikProps,
              name: `${type}_room_rent_remarks`,
            }}
          />
        </RoomRentContainer>
      </div>
    );
  };

  const handleMetroToggle = (value, onChange) => {
    if (!toggleStatus) return;
    formikProps.setFieldValue("room_rent_metro_toggler", !value);
  };

  return attribute ? (
    <GradeAccordion
      title="Room Rent Limit"
      showSwitch={attribute?.toggle}
      canSelect={toggleStatus}
      setToggleStatus={interstitialToggler}
     expanded={toggleStatus}
    >
      <section>
        {options.length === 0 ? (
          <div
            style={{
              maxWidth: "300px",
              marginBottom: "24px",
            }}
          >
            <Field name="room_rent_metro_toggler">
              {({
                field, // { name, value, onChange, onBlur }
              }) => (
                <DependentsCard
                  handleClick={() =>
                    handleMetroToggle(field.value, field.onChange)
                  }
                  selected={field.value}
                >
                  <Ptag>
    Split Coverage by Metro/ Non-Metro
                  </Ptag>
              
                </DependentsCard>
              )}
            </Field>
          </div>
        ) : null}
        {formikProps.values.room_rent_metro_toggler ? (
          <RoomRentContainer>
            {renderMetroNonMetro("metro")}
            {renderMetroNonMetro("non_metro")}
          </RoomRentContainer>
        ) : doesRangeExist ? (
          <>
            <div className="sum-insured-container">
              <BaseDropdown
                staticLabel="Limit"
                fontSize="16"
                options={options}
                disabled={!toggleStatus}
                formikProps={{ ...formikProps, name: "room_rent_limit" }}
              />             
              {doesRangeExist && isFlex && (
                <div>
                  <Ptag
                    color={colors.primaryColor}
                    fontSize="14px"
                    marginBottom="10px"
                  >
                    Range
                  </Ptag>
                  <div className="sum-insured-container">
                    <BaseDropdown
                      fontSize="16"
                      label="Min"
                      disabled={!toggleStatus}
                      options={options}
                      formikProps={{
                        ...formikProps,
                        name: "room_rent_limit_min",
                      }}
                    />
                    <BaseDropdown
                      fontSize="16"
                      label="Max"
                      disabled={!toggleStatus}
                      options={options}
                      formikProps={{
                        ...formikProps,
                        name: "room_rent_limit_max",
                      }}
                    />
                  </div>               
                </div>
              )}
            </div>
            {/* <div
            className="sum-insured-container"
            style={{
              marginTop: "1.4rem",
            }}
          >
            <BaseInput
              staticLabel="Max Per Day Limit for Normal Room (optional)"
              disabled={!toggleStatus}
              type="text"
              fontSize="16px !important"
              formikProps={{
                ...formikProps,
                name: "room_rent_limit_max_normal",
              }}
            />
            <BaseInput
              staticLabel="Max per day limit for ICU (optional)"
              disabled={!toggleStatus}
              fontSize="16px !important"
              type="text"
              formikProps={{
                ...formikProps,
                name: "room_rent_limit_max_icu",
              }}
            />
          </div> */}
            {/* <div
            style={{
              marginTop: "1.4rem",
            }}
          > */}
            <BaseInput
              fontSize="16px !important"
              staticLabel="Remarks (optional)"
              disabled={!toggleStatus}
              type="text"
              formikProps={{ ...formikProps, name: "room_rent_remarks" }}
            />
            {/* </div> */}
          </>
        ) : (
          <RoomRentContainer>
            {renderMetroNonMetro("default_metro", "split")}
          </RoomRentContainer>
        )}
      </section>
    </GradeAccordion>
  ) : null;
};

export default GradeRoomLimit;
